import React, { useState } from "react";
import styled from "styled-components";
import dummyUserImg from "../../../shared/general/img/dummyUserImg.png";

const StyledImage = styled.img`
  width: 42px;
  height: 42px;
  border-radius: 50%;
  object-fit: cover;
`;

const AgencyImage = ({ src, alt }) => {
  const [imgSrc, setImgSrc] = useState(src);

  const handleError = () => {
    setImgSrc(dummyUserImg);
  };

  return <StyledImage src={imgSrc} alt={alt} onError={handleError} />;
};

export default AgencyImage;
